import { call, put, all } from 'typed-redux-saga'
import * as consumerAuthenticationActions from '../../actions/consumerDataPullSessionActions/consumerAuthenticationActions'
import * as psd2ConsentActions from '../../actions/consumerDataPullSessionActions/psd2ConsentActions'
import {
	AuthenticateFailedAction,
	AuthenticateSucceededAction,
} from '../../actions/consumerDataPullSessionActions/consumerAuthenticationActions'
import { closeConsumerDataPullSessionSucceeded } from '../../actions/consumerDataPullSessionActions/closeConsumerDataPullSessionActions'
import { transactionApiClient } from '../../../../../api/transactionApiClient'

export function* authenticateWithSessionIdSaga(
	action: consumerAuthenticationActions.AuthenticateWithSessionIdAction,
): Generator<
	any,
	void,
	AuthenticateSucceededAction | AuthenticateFailedAction
> {
	const sessionId = action.payload.sessionId
	try {
		const applicantSessionAuthenticationDto = yield* call(
			transactionApiClient.registerSessionAndGetConsent,
		)

		yield all([
			put(
				psd2ConsentActions.setPsd2ConsentGiven(
					applicantSessionAuthenticationDto.psd2Consent,
				),
			),
			put(
				consumerAuthenticationActions.authenticateSucceeded(
					sessionId,
					applicantSessionAuthenticationDto,
				),
			),
			applicantSessionAuthenticationDto.finishedOn
				? put(closeConsumerDataPullSessionSucceeded())
				: null,
		])
	} catch (error: any) {
		yield put(
			consumerAuthenticationActions.authenticateFailed({
				name: error.name,
				errorCode: error.errorCode,
				errorText: error.name + ': ' + error.message,
				data: error.data,
			}),
		)
	}
}
